export var TechnologyType;
(function (TechnologyType) {
    TechnologyType["FTTP"] = "FTTP";
    TechnologyType["FTTN"] = "FTTN";
    TechnologyType["FTTB"] = "FTTB";
    TechnologyType["FTTC"] = "FTTC";
    TechnologyType["HFC"] = "HFC";
    TechnologyType["WIRELESS"] = "WIRELESS";
    TechnologyType["SATELLITE"] = "SATELLITE";
    TechnologyType["REDTRAIN"] = "REDTRAIN";
})(TechnologyType || (TechnologyType = {}));
